import { Feature } from 'geojson';

/**
 *
 * Metoder för att filtrera och sortera bland Features och FeatureCollections
 *
 **/
export class FeatureUtils {
  /*
    Sortera ut samtliga objekt inklusive GAANLÄGGN (Gemensamhetsanläggning)
     */
  static tvattaBortOtillatnaDetaljtyperIFeatureCollection = (listObj: any) => {
    return listObj.features
      .filter((feature: any) => feature.properties['objekt_id'] !== null)
      .filter(
        (fetature: any) =>
          fetature.properties['detaljtyp'] === 'FASTIGHET' ||
          fetature.properties['detaljtyp'] === '3DFASTIGH' ||
          fetature.properties['detaljtyp'] === 'FASTO' ||
          fetature.properties['detaljtyp'] === 'GAANLÄGGN' ||
          fetature.properties['detaljtyp'] === 'SAMF' ||
          fetature.properties['detaljtyp'] === 'FISKESAMF'
      );
  };

  static isGodkandDetaljtypFeatureCollection = (listObj: any): boolean => {
    return (
      listObj.features[0].properties['detaljtyp'] === 'FASTIGHET' ||
      listObj.features[0].properties['detaljtyp'] === '3DFASTIGH' ||
      listObj.features[0].properties['detaljtyp'] === 'SAMF' ||
      listObj.features[0].properties['detaljtyp'] === 'FISKESAMF' ||
      listObj.features[0].properties['detaljtyp'] === 'FASTO'
    );
  };

  static isGodkandDetaljtypFeatures = (listObj: any): boolean => {
    return (
      listObj.properties['detaljtyp'] === 'FASTIGHET' ||
      listObj.properties['detaljtyp'] === '3DFASTIGH' ||
      listObj.properties['detaljtyp'] === 'SAMF' ||
      listObj.properties['detaljtyp'] === 'FISKESAMF' ||
      listObj.properties['detaljtyp'] === 'FASTO'
    );
  };

  static isGodkandDetaljtypInObjektlistCollection = (
    objLista: any
  ): boolean => {
    return (
      objLista.json.features[0].properties['detaljtyp'] === 'FASTIGHET' ||
      objLista.json.features[0].properties['detaljtyp'] === '3DFASTIGH' ||
      objLista.json.features[0].properties['detaljtyp'] === 'SAMF' ||
      objLista.json.features[0].properties['detaljtyp'] === 'FISKESAMF' ||
      objLista.json.features[0].properties['detaljtyp'] === 'FASTO'
    );
  };

  static isGodkandDetaljtypInObjektlista = (objLista: any): boolean => {
    return (
      objLista.json.properties['detaljtyp'] === 'FASTIGHET' ||
      objLista.json.properties['detaljtyp'] === '3DFASTIGH' ||
      objLista.json.properties['detaljtyp'] === 'FASTO' ||
      objLista.json.properties['detaljtyp'] === 'SAMF' ||
      objLista.json.properties['detaljtyp'] === 'FISKESAMF'
    );
  };

  static getKommunOchFastighetIFeatureCollection = (listObj: any): string => {
    return (
      listObj.json.features[0].properties['kommunnamn'] +
      ' ' +
      listObj.json.features[0].properties['fastighet'].split('>')[0]
    );
  };

  static getKommunnamnTraktBlockenhetIFeatureCollection = (
    listObj: any
  ): string => {
    return (
      listObj.json.features[0].properties['kommunnamn'] +
      ' ' +
      listObj.json.features[0].properties['trakt'] +
      ' ' +
      listObj.json.features[0].properties['blockenhet']
    );
  };

  static getKommunOchFastighetFranFeature = (listObj: any): string => {
    return (
      listObj.json.properties['kommunnamn'] +
      ' ' +
      listObj.json.properties['fastighet']
    );
  };

  static getKommunnamnTraktBlockenhetFranFeature = (listObj: any): string => {
    return (
      listObj.json.properties['kommunnamn'] +
      ' ' +
      listObj.json.properties['trakt'] +
      ' ' +
      listObj.json.properties['blockenhet']
    );
  };

  static existsGAANLAGGNING = (featureCollection: any) => {
    return featureCollection.some(
      (feature) => feature.properties['detaljtyp'] === 'GAANLÄGGN'
    );
  };

  static existObjektId = (listObj: any) => {
    return listObj.some((feature: any) => feature.properties.objekt_id);
  };

  static removeDuplicatesOfRattigheter = (listOfFeatures: Feature[]) => {
    const fastighetsytor = listOfFeatures.filter(
      (feature) =>
        typeof feature.id === 'string' &&
        feature.id.startsWith('Fastighetsytor_WFS')
    );
    const rattigheter = listOfFeatures.filter(
      (feature) =>
        typeof feature.id === 'string' &&
        !feature.id.startsWith('Fastighetsytor_WFS')
    );
    const uniqueRattigheter: string[] = [];

    const filteredRattigheter = rattigheter.filter((feature) => {
      if (feature.properties === null) {
        return true;
      }
      const currentObjektId = feature.properties['objekt_id'];
      const isDuplicate = uniqueRattigheter.includes(currentObjektId);

      if (isDuplicate) {
        return false;
      }
      uniqueRattigheter.push(currentObjektId);
      return true;
    });

    return fastighetsytor.concat(filteredRattigheter);
  };

  static isFeatureDuplicate = (befintligaFeatures: any[], json: any[]) => {
    const befintligaFeatureIds = befintligaFeatures.map((feature) =>
      feature.getId()
    );
    const nyaFeatureIds = json.map((feature) => feature.id);

    return befintligaFeatureIds.some((x) => nyaFeatureIds.includes(x));
  };

  static getEventuelltKommunNanmnFranFeatureCollection = (
    featureCollection: any
  ) => {
    const eventuelltKommunnamn = featureCollection
      .filter((feature) => feature.properties['kommunnamn'] !== undefined)
      .map((feature) => feature.properties['kommunnamn']);

    return eventuelltKommunnamn.length > 0 ? eventuelltKommunnamn[0] : '';
  };

  static addKommunnamnToGAAnlaggning = (
    featureArray: any,
    kommunnamn: string
  ) => {
    featureArray
      .filter((feature) => feature.properties['detaljtyp'] === 'GAANLÄGGN')
      .forEach((feature) => {
        feature.properties.kommunnamn = kommunnamn;
      });
  };

  static hamtaForstaBeteckningen = (json: any) => {
    const firstElement = json[0];

    if (firstElement.type === 'FeatureCollection') {
      if (FeatureUtils.isGodkandDetaljtypFeatureCollection(firstElement)) {
        return (
          firstElement.features[0].properties['kommunnamn'] +
          ' ' +
          firstElement.features[0].properties['fastighet'].split('>')[0]
        );
      } else {
        return (
          firstElement.features[0].properties['kommunnamn'] +
          ' ' +
          firstElement.features[0].properties['trakt'] +
          ' ' +
          firstElement.features[0].properties['blockenhet']
        );
      }
    } else if (firstElement.type === 'Feature') {
      if (FeatureUtils.isGodkandDetaljtypFeatures(firstElement)) {
        return (
          firstElement.properties['kommunnamn'] +
          ' ' +
          firstElement.properties['fastighet']
        );
      } else {
        return (
          firstElement.properties['kommunnamn'] +
          ' ' +
          firstElement.properties['trakt'] +
          ' ' +
          firstElement.properties['blockenhet']
        );
      }
    } else {
      throw new Error('Unexpected type ' + firstElement.type);
    }
  };

  static getBeteckningMedObjektID = (listObj: any, objektID: string) => {
    if (listObj.type === 'FeatureCollection') {
      return listObj.features[0].properties['objekt_id'] === objektID;
    } else if (listObj.type === 'Feature') {
      return listObj.properties['objekt_id'] === objektID;
    } else {
      throw new Error('Unexpected type ' + listObj.type);
    }
  };

  static getAllaBeteckningarUtomMedAngivetObjektID = (
    listObj: any,
    objektID: string
  ) => {
    if (listObj.type === 'FeatureCollection') {
      return listObj.features[0].properties['objekt_id'] !== objektID;
    } else if (listObj.type === 'Feature') {
      return listObj.properties['objekt_id'] !== objektID;
    } else {
      throw new Error('Unexpected type ' + listObj.type);
    }
  };

  static getAllaUtomAngivenBeteckning = (listObj: any, bet: string) => {
    if (listObj.type === 'FeatureCollection') {
      if (FeatureUtils.isGodkandDetaljtypFeatureCollection(listObj)) {
        return (
          listObj.features[0].properties['kommunnamn'] +
            ' ' +
            listObj.features[0].properties['fastighet'].split('>')[0] !==
          bet
        );
      } else {
        return (
          listObj.features[0].properties['kommunnamn'] +
            ' ' +
            listObj.features[0].properties['trakt'] +
            ' ' +
            listObj.features[0].properties['blockenhet'] !==
          bet
        );
      }
    } else if (listObj.type === 'Feature') {
      if (FeatureUtils.isGodkandDetaljtypFeatures(listObj)) {
        return (
          listObj.properties['kommunnamn'] +
            ' ' +
            listObj.properties['fastighet'] !==
          bet
        );
      } else {
        return (
          listObj.properties['kommunnamn'] +
            ' ' +
            listObj.properties['trakt'] +
            ' ' +
            listObj.properties['blockenhet'] !==
          bet
        );
      }
    } else {
      throw new Error('Unexpected type ' + listObj.type);
    }
  };

  static getAngivenBeteckning = (listObj: any, bet: string) => {
    if (listObj.type === 'FeatureCollection') {
      if (FeatureUtils.isGodkandDetaljtypFeatureCollection(listObj)) {
        return (
          listObj.features[0].properties['kommunnamn'] +
            ' ' +
            listObj.features[0].properties['fastighet'].split('>')[0] ===
          bet
        );
      } else {
        return (
          listObj.features[0].properties['kommunnamn'] +
            ' ' +
            listObj.features[0].properties['trakt'] +
            ' ' +
            listObj.features[0].properties['blockenhet'] ===
          bet
        );
      }
    } else if (listObj.type === 'Feature') {
      if (FeatureUtils.isGodkandDetaljtypFeatures(listObj)) {
        return (
          listObj.properties['kommunnamn'] +
            ' ' +
            listObj.properties['fastighet'] ===
          bet
        );
      } else {
        return (
          listObj.properties['kommunnamn'] +
            ' ' +
            listObj.properties['trakt'] +
            ' ' +
            listObj.properties['blockenhet'] ===
          bet
        );
      }
    } else {
      throw new Error('Unexpected type ' + listObj.type);
    }
  };

  static getAllaBeteckningarFranObjektlista = (listObj: any) => {
    if (listObj.json.type === 'FeatureCollection') {
      if (FeatureUtils.isGodkandDetaljtypInObjektlistCollection(listObj)) {
        return FeatureUtils.getKommunOchFastighetIFeatureCollection(listObj);
      } else {
        return FeatureUtils.getKommunnamnTraktBlockenhetIFeatureCollection(
          listObj
        );
      }
    } else if (listObj.json.type === 'Feature') {
      if (FeatureUtils.isGodkandDetaljtypInObjektlista(listObj)) {
        return FeatureUtils.getKommunOchFastighetFranFeature(listObj);
      } else {
        return FeatureUtils.getKommunnamnTraktBlockenhetFranFeature(listObj);
      }
    } else {
      throw new Error('Unexpected type ' + listObj.json.type);
    }
  };

  static togglaEnMarkeringFranObjektLista = (listObj: any, bet: string) => {
    let beteckning;

    if (listObj.json.type === 'FeatureCollection') {
      if (FeatureUtils.isGodkandDetaljtypInObjektlistCollection(listObj)) {
        beteckning =
          FeatureUtils.getKommunOchFastighetIFeatureCollection(listObj);
      } else if (
        listObj.json.features[0].properties['detaljtyp'] === 'GAANLÄGGN'
      ) {
        beteckning =
          FeatureUtils.getKommunnamnTraktBlockenhetIFeatureCollection(listObj);
      }
    } else if (listObj.json.type === 'Feature') {
      if (FeatureUtils.isGodkandDetaljtypInObjektlista(listObj)) {
        beteckning = FeatureUtils.getKommunOchFastighetFranFeature(listObj);
      } else if (listObj.json.properties['detaljtyp'] === 'GAANLÄGGN') {
        beteckning =
          FeatureUtils.getKommunnamnTraktBlockenhetFranFeature(listObj);
      }
    }

    if (beteckning === bet) {
      return { ...listObj, markerad: !listObj.markerad };
    } else {
      return listObj;
    }
  };

  static togglaEnMarkeringFranObjektListaMedObjektId = (
    listObj: any,
    bet: string
  ) => {
    let objektID;
    if (listObj.json.type === 'FeatureCollection') {
      objektID = listObj.json.features[0].properties.objekt_id;
    } else if (listObj.json.type === 'Feature') {
      objektID = listObj.json.properties['objekt_id'];
    }
    if (objektID === bet) {
      return { ...listObj, markerad: !listObj.markerad };
    } else {
      return listObj;
    }
  };
}
